import { MembershipSettings, Organization, Permissions } from '@/common/models';
import LocalCache from '@/utils/LocalCache';

interface IState {
  organization: Organization;
  organizationSettings: MembershipSettings;
  useWizardForLineItemForEditing: boolean;
  permissions: Permissions;
}

const initialState: IState = {
  organization: null,
  organizationSettings: null,
  useWizardForLineItemForEditing:
    LocalCache.get('useLineItemWizard') != null ? LocalCache.get('useLineItemWizard') === 'true' : false,
  permissions: null,
};

export default initialState;
